module.exports = __webpack_public_path__ + "img/tarif-connect-motiv-p-500.9c3e64a5.jpeg";